import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "text-xl text-black mb-2" }, "Detail Pengiriman", -1)
const _hoisted_2 = { class: "background-grey-lighten-5 px-5 py-5 mb-4" }
const _hoisted_3 = { class: "font-bold text-xl text-black mb-1" }
const _hoisted_4 = { class: "font-bold text-4xl text-black" }
const _hoisted_5 = { class: "mb-4" }
const _hoisted_6 = { class: "grid md:grid-cols-2 grid-cols-1 gap-2" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey text-sm" }, "Pengirim", -1)
const _hoisted_8 = { class: "mb-1 break-all text-sm" }
const _hoisted_9 = { class: "mb-1 break-all text-sm" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "font-semibold mb-1 color-blue-grey text-sm" }, "Penerima", -1)
const _hoisted_11 = { class: "mb-1 break-all text-sm" }
const _hoisted_12 = { class: "mb-1 break-all text-sm" }
const _hoisted_13 = { class: "background-grey-lighten-5 p-2 mb-4" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "font-bold text-xl mb-1" }, "Pengakuan Barang", -1)
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "w-1/4" }, "Definisi Harga", -1)
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "w-1/4" }, "Harga Barang", -1)
const _hoisted_19 = { class: "background-grey-lighten-5 p-2 mb-4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "flex w-full justify-between items-center" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-bold text-xl mb-1" }, "Pembayaran"),
  /*#__PURE__*/_createVNode("div", {
    class: "rounded text-white py-1 px-3 text-xs",
    style: {"background-color":"#66BB6A"}
  }, " Lunas ")
], -1)
const _hoisted_21 = { class: "flex w-full justify-between items-center" }
const _hoisted_22 = /*#__PURE__*/_createVNode("p", { class: "font-semibold" }, "Total Harga", -1)
const _hoisted_23 = { class: "font-semibold text-2xl" }
const _hoisted_24 = { class: "flex items-center p-4 w-full justify-between" }
const _hoisted_25 = /*#__PURE__*/_createVNode("p", { class: "font-normal" }, "List Barang", -1)
const _hoisted_26 = { class: "font-normal" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Total ")
const _hoisted_28 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_29 = { class: "font-semibold text-black px-4 h-14 flex items-center" }
const _hoisted_30 = { class: "font-semibold text-black px-4 h-14 flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, "#" + _toDisplayString(_ctx.data.Resi), 1),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.data.TipePengiriman), 1),
      _createVNode("p", _hoisted_5, _toDisplayString(_ctx.data.KotaAsalNama) + " - " + _toDisplayString(_ctx.data.KotaTujuanNama), 1),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", null, [
          _hoisted_7,
          _createVNode("p", _hoisted_8, _toDisplayString(`${_ctx.data.NamaPengirim} (${_ctx.data.HpPengirim})`), 1),
          _createVNode("p", _hoisted_9, _toDisplayString(_ctx.data.AlamatPengirim), 1)
        ]),
        _createVNode("div", null, [
          _hoisted_10,
          _createVNode("p", _hoisted_11, _toDisplayString(`${_ctx.data.NamaPenerima} (${_ctx.data.HpPenerima})`), 1),
          _createVNode("p", _hoisted_12, _toDisplayString(_ctx.data.AlamatPenerima), 1)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_13, [
      _hoisted_14,
      _createVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode("div", null, ": " + _toDisplayString(_ctx.data.PengakuanIsiBarang ?? '-'), 1)
      ]),
      _createVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode("div", null, ": Rp. " + _toDisplayString(_ctx.rupiahFormat(_ctx.data.PengakuanNilaiBarang)), 1)
      ])
    ]),
    _createVNode("div", _hoisted_19, [
      _hoisted_20,
      _createVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode("p", _hoisted_23, "Rp. " + _toDisplayString(_ctx.rupiahFormat(_ctx.data.GrandTotal)), 1)
      ])
    ]),
    (_ctx.data.TransPengirimanDetails)
      ? (_openBlock(), _createBlock(_component_Card, {
          key: 0,
          class: "card-no-shadow card-p-0 mb-5"
        }, {
          content: _withCtx(() => [
            _createVNode("div", _hoisted_24, [
              _hoisted_25,
              _createVNode("p", _hoisted_26, [
                _hoisted_27,
                _createVNode("b", null, _toDisplayString(_ctx.data.TransPengirimanDetails.length) + " Koli", 1)
              ])
            ]),
            _createVNode(_component_DataTable, {
              value: _ctx.data.TransPengirimanDetails,
              class: "table-og body-td-x-0",
              responsiveLayout: "scroll"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, { header: "Satuan" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", _hoisted_28, _toDisplayString(slotProps.data.Berat), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Kategori Barang" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", _hoisted_29, _toDisplayString(slotProps.data.KategoriBarangNama), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "Biaya Barang" }, {
                  body: _withCtx((slotProps) => [
                    _createVNode("p", _hoisted_30, " Rp. " + _toDisplayString(_ctx.rupiahFormat(slotProps.data.TotalHarga)), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}